import React, { useEffect } from 'react'

// import './App.css';
import Properties from './components/Properties'

import AnchorLink from "react-anchor-link-smooth-scroll";

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

const App = () => {
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger)
    setAnimation()
    setAnimationLineTop()
    setAnimationLineFooter()
    setAnimationLineCompany()
  }, [])

  const setAnimation = () => {
    gsap.fromTo(
      '.ani img',
      {
        opacity: 0,
        y: 30
      },
      {
        opacity: 1,
        y: 0,
        ease: "power1.out",
        duration: .8,
        scrollTrigger: {
          trigger: '.ani',
          start: 'top 40%',
          end: 'bottom 40%',
          onEnter: () => {
            // console.log('scroll In')
          },
          onEnterBack: () => {
            // console.log('scroll Back')
          },
          // markers: true
        }
      }
    )
  }

  const setAnimationLineTop = () => {
    gsap.fromTo(
      '.ani3',
      {
        width: 0
      },
      {
        width: 'auto',
        duration: .6,
        scrollTrigger: {
          trigger: '.ani3',
          start: 'top 90%',
          end: 'bottom 90%',
          ease: "power1.out",
          onEnter: () => {
            // console.log('scroll In')
          },
          onEnterBack: () => {
            // console.log('scroll Back')
          },
          // markers: true
        }
      }
    )
  }

  const setAnimationLineFooter = () => {
    gsap.fromTo(
      '.ani4',
      {
        width: 0
      },
      {
        width: 'auto',
        duration: .6,
        scrollTrigger: {
          trigger: '.ani4',
          start: 'top 90%',
          end: 'bottom 90%',
          ease: "power1.out",
          onEnter: () => {
            // console.log('scroll In')
          },
          onEnterBack: () => {
            // console.log('scroll Back')
          },
          // markers: true
        }
      }
    )
  }

  const setAnimationLineCompany = () => {
    gsap.fromTo(
      '.company .box hr',
      {
        height: 0
      },
      {
        height: '100%',
        duration: .6,
        delay: 0.5,
        stagger: 0.2,
        ease: "power1.out",
        scrollTrigger: {
          trigger: '.company .box hr',
          start: 'top 60%',
          end: 'bottom 40%',
          onEnter: () => {
            // console.log('scroll In')
          },
          onEnterBack: () => {
            // console.log('scroll Back')
          },
          // markers: true
        }
      }
    )
  }

  return (
    <div className="home">
      <header className="header">
        <div className="inner">
          <div className="headding">
            <h1><span>AM</span> REAL ESTATE</h1>
            <div>株式会社エーエムリアルエステート</div>
            <hr className='ani3' />
          </div>
          <figure className='ani'>
            <img src="./assets/img/main.png" alt="株式会社エーエムリアルエステート" />
          </figure>
        </div>
      </header>

      <nav>
        <ul>
          <li><a href="/">HOME</a></li>
          <li><AnchorLink href="#properties">PROPERTIES</AnchorLink></li>
          <li><AnchorLink href="#company">COMPANY</AnchorLink></li>
        </ul>
      </nav>

      <section id="properties" className="properties">
        <div className="inner">
          <div className="headding">
            <h2>PROPERTIES</h2>
            <div>所有物件</div>
          </div>
          <Properties />
        </div>
      </section>

      <section id="company" className="company">
        <div className="inner">
          <div className="headding">
            <h2>COMPANY</h2>
            <div>会社概要</div>
          </div>
          <div className="body">
            <div className="adddress box small">
              <div className="head">ADDRESS</div>
              <div className="head__sub">所在地</div>
              <div className="desc">株式会社エーエムリアルエステート<br />〒135-0061 東京都江東区豊洲２丁目５−２</div>
              <hr />
            </div>
            <div className="ceo box small">
              <div className="head">CEO</div>
              <div className="head__sub">代表</div>
              <div className="desc">
                代表取締役　田中貴雅<br />
                設立：2009年6月<br />
                代表：03-5547-5885<br />
              </div>
              <hr />
            </div>
            <div className="business box small">
              <div className="head">BUSINESS CONTENT</div>
              <div className="head__sub">業務内容</div>
              <div className="desc">
                不動産賃貸業<br />
                土地を取得、建築後　賃貸<br />
                区分店舗、区分マンション等を取得して賃貸<br />
              </div>
              <hr />
            </div>
            <div className="balance box large">
              <div className="head">BALANCE SHEET</div>
              <div className="head__sub">バランスシート</div>
              <div className="desc">
                <div>準備中</div>

                {/* <table>
                  <thead>
                    <tr className="border__bottom">
                      <th className="border__right"></th>
                      <th className="border__right">先期(令和2年)</th>
                      <th className="border__right">今期(令和3年)</th>
                      <th>来期予定(令和4年)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="border__right">総資産<br />有利子負債</td>
                      <td className="border__right txt__right">1,034,076千円<br />450,100千円</td>
                      <td className="border__right txt__right">1,140,000千円<br />512,000千円</td>
                      <td className="txt__right">1,210,000千円<br />573,000千円</td>
                    </tr>
                  </tbody>
                </table> */}
              </div>
              <hr />
            </div>
            <div className="trading box small">
              <div className="head">TRADING RECORD</div>
              <div className="head__sub">売買実績</div>
              <div className="desc">
                千葉県市川市　集合住宅一棟<br />
                東京都中央区勝どき　ビル1棟<br />
                東京都中央区銀座 　ビル2棟<br />
                東京都台東区雷門　ビル1棟<br />
                長野県北佐久郡軽井沢町　戸建(別荘)<br />
              </div>
              <hr />
            </div>
          </div>
        </div>
      </section>

      <AnchorLink href="#root" className='btn up'>TOP</AnchorLink>

      <footer>
        <div className='line'><hr className='ani4' /></div>
        Copyright ©︎2021 AM real estate. All Right Reserved.
      </footer>
    </div>
  );
}

export default App;
